var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb53c1e0-8e03-45cb-883f-9dc02e2d8ce2",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 115.9922 94.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117,24.99a47.6041,47.6041,0,0,1-13.6775,3.7516A23.857,23.857,0,0,0,113.7908,15.58a47.784,47.784,0,0,1-15.1149,5.7676,23.8075,23.8075,0,0,0-40.5444,21.705,67.5709,67.5709,0,0,1-49.051-24.869,23.8484,23.8484,0,0,0,7.3676,31.7846A23.7757,23.7757,0,0,1,5.6634,46.9845v.2983A23.83,23.83,0,0,0,24.7468,70.6241a23.8116,23.8116,0,0,1-6.2647.8317,22.9217,22.9217,0,0,1-4.4838-.434A23.8513,23.8513,0,0,0,36.2276,87.556,47.7039,47.7039,0,0,1,6.6759,97.735a46.7909,46.7909,0,0,1-5.6681-.3345,67.2344,67.2344,0,0,0,36.4764,10.6944c43.7717,0,67.71-36.2595,67.71-67.7006,0-1.0305-.0272-2.07-.0633-3.0826A48.3771,48.3771,0,0,0,117,24.99Z",
    transform: "translate(-1.0078 -13.8348)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c704d23d.svg";
export { ForwardRef as ReactComponent };